<template>
<CRow>
  <CCol col="12" xl="12">
    <CCard>
      <CCardHeader>
        <CCol col="6" style="font-size: 25px;">عرض الوحدة </CCol>
      </CCardHeader>
      <CCardBody>
        <div class="row">
            <div class="col-md-6">
                <table class="table table-bordered">
                  <tr>
                    <th>التصنيف</th>
                    <td>{{ selectedCategory.name }}</td>
                  </tr>
                  <tr>
                    <th>التصنيف الفرعية</th>
                    <td>{{ selectedSubCategory.name }}</td>
                  </tr>
                  <tr>
                    <th>الكورس</th>
                    <td>{{ selectedCourse.name }}</td>
                  </tr>
                </table>
            </div>
            <div class="col-md-6">
              <table class="table table-bordered">
                  <tr>
                    <th>الاسم</th>
                    <td>{{ section.name }}</td>
                  </tr>
                  <tr>
                    <th> الاسم بالعربي</th>
                    <td>{{ section.name_ar }}</td>
                  </tr>
                  <tr>
                    <th>الوصف</th>
                    <td>{{ section.description }}</td>
                  </tr>
                  <tr>
                    <th>الوصف بالعربي</th>
                    <td>{{ section.description_ar }}</td>
                  </tr>
                </table>
            </div>
        </div>
        <CButton color="warning" @click="goBack">رجوع</CButton>
      </CCardBody>
    </CCard>
  </CCol>
</CRow>
</template>

<script>
export default {
  name: 'ShowSection',
  data () {
    return {
      section: [],
      selectedCourse: '',
      selectedSubCategory: '',
      selectedCategory: ''
    }
  },
  created () {
    this.$http
      .get(`${this.$hostUrl}sections/${this.$route.params.id}/edit`)
      .then((response) => {
        this.section = response.data.data.section
        this.selectedCourse = {
          id: this.section.course.id,
          name: this.section.course.name_ar
        }
        this.selectedSubCategory = {
          id: this.section.course.sub_category.id,
          name: this.section.course.sub_category.name_ar
        }
        this.selectedCategory = {
          id: this.section.course.sub_category.category.id,
          name: this.section.course.sub_category.category.name_ar
        }
      })
  },
  methods: {
    goBack () {
      this.$router.push({ path: '/sections' })
    }
  }
}
</script>
<style scoped>
  th {
    background-color: #3c4b64;
    color: #f5f3f3;
  }
</style>
